import { ModalErrorState } from '@/models/modal.interface';
import { Interval } from '@/models/timing.interface';
import rollbarOperator from '@/infrastructure/rollbar-operator';
import store from '@/store';

class TableauJWTPresenter {
	private intervalHandle: Interval | null = null;
	private contextIsUniAdmin: boolean;
	
	constructor() {
		this.contextIsUniAdmin = window.location.host.includes('administration');
	}

	public async startTableauJWTFetchLoop(): Promise<void> {
		if (!this.contextIsUniAdmin || this.intervalHandle) {
			return;
		}

		await this.fetchNewTableauJWT();

		this.intervalHandle = setInterval(
			() => void this.fetchNewTableauJWT(),
			4 * 60 * 1000
		);
	}

	public stopTableauJWTFetchLoop(): void {
		if (!this.intervalHandle) {
			return;
		}

		clearInterval(this.intervalHandle);
		this.intervalHandle = null;
	}	

	private async fetchNewTableauJWT(): Promise<void> {
		const placeholderElement: HTMLDivElement | null = document.querySelector('.js-enrolmentTool');
		const instanceId = placeholderElement?.dataset.instanceId;
		if (!instanceId) {
			rollbarOperator.triggerError(new Error('Data prop "instance_id" not found on the microservice placeholder element.'));
			store.mutations.setModalErrorState(ModalErrorState.RETRIEVE_JWT_INSTANCE_ID);
			return;
		}

		const params = new URLSearchParams({
			instance_id: instanceId,
			action: 'getTableauToken'
		});

		try {
			const response = await fetch(
				`/Ajax.php?${params.toString()}`,
				{
					method: 'GET',
					cache: 'no-store'
				}
			);

			const result = await response.json();
			store.mutations.setTableauJWT(result.token as string);
		} catch (error) {
			rollbarOperator.triggerError(error as Error);
			store.mutations.setModalErrorState(ModalErrorState.RETRIEVE_JWT);
		}
	}
}

export default new TableauJWTPresenter();
